/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ApplicationWizardStep {
  COMPANY_INFORMATION = 'company_information',
  REVIEW_SAFER = 'review_safer',
  BUSINESS_STRUCTURE = 'business_structure',
  TEXAS_AGENT = 'texas_agent',
  INTERSTATE_UCR = 'interstate_ucr',
  REGISTRATION_PERIOD = 'registration_period',
  CARGO_TYPES = 'cargo_types',
  VEHICLES = 'vehicles',
  DRUG_TEST_CERTIFICATION = 'drug_test_certification',
  QUESTIONNAIRE = 'questionnaire',
  REVIEW_AND_SUBMIT = 'review_and_submit',
}
